import axios from 'axios';
import { variables } from "../Variables";

export const getOfficeLogoService = async (officeId) => {
    try {
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetLogoByOfficeId/${officeId}`;
        const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
        if (response.data) {
            let url = response.data;
            if (url && url.logoUrl) {
                let fileName = url.logoUrl.split("UploadedFiles/")[1];
                let imgUrl = `${variables.API_URL.split("/api")[0]}/UploadedFiles/${fileName}`;
                return imgUrl;
                //setOfficeLogoUrl(imgUrl);
            }
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export const getContactTitleListService = async (clientToken) => {
    try {
        let url = "https://api.whise.eu/v1/contacts/titles/list";

        const jsonConfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${clientToken}`
            }
        }

        let body = {};

        const response = await axios.post(url, body, jsonConfig);
        if (response.data) {
            return response.data.contactTitles;
        }
    } catch (error) {
        console.log("error", error);
    }
}

export const getClientSettingService = async (token, clientId) => {
    try {
        let url = 'https://api.whise.eu/v1/admin/clients/settings';

        const jsonConfig = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }

        let body = {
            ClientId: clientId
        };

        const response = await axios.post(url, body, jsonConfig);
        if (response.data.settings) {
            return response.data.settings;
        }
    } catch (error) {
        console.log("error", error);
    }
}

export const formatDateTimeLanguageSpecificService = (locale, dateStr) => {

    const eventDate = new Date(dateStr);

    // Extract local parts manually to avoid timezone conversions
    const year = eventDate.getFullYear();
    const month = eventDate.getMonth();
    const day = eventDate.getDate();
    const hours = eventDate.getHours();
    const minutes = eventDate.getMinutes();

    // Create a date object using UTC (so Intl won't shift it)
    const fixedDate = new Date(Date.UTC(year, month, day, hours, minutes));

    const formatter = new Intl.DateTimeFormat(locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,  // Change to true if you need 12-hour format
        timeZone: "UTC", //timeZones[clientLanguage], // Specify the desired timezone
        //timeZoneName: "long", // Change to true if you need 12-hour format
    });

    return formatter.format(fixedDate);
}

export const convertTBCToConfirmedEvent = async (body) => {

    try {
        let url = `${variables.API_URL}LocalEvents/TobeConfirmedToConfirmedEventHandling`;
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.post(url, body, config);
        if (response.data) {
            console.log(response.data);
           // setEventStatus(response.data.type);
        }
      
    } catch (error) {
        console.log(error);
    }

}

// get latest estate id from estate history db 
export const getLatestEstateIdFromDB = async (estateId) => {
    try {
        let url = `${variables.API_URL}Estate/GetEstateLatestId?inputEstateId=${estateId}`;
        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

export const saveAutomaticAcceptSetting = async (body) => {
    try {
        let url = `${variables.API_URL}Preferences/SaveEstateOrOfficeSetting`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.post(url, body, jsonconfig);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// get estate and office setting from local db
export const getEstateAndOfficeSettingAgentsite = async (payload) => {
    try {
        let url = `${variables.API_URL}Preferences/GetEstateOrOfficeSetting?clientId=${payload.clientId}&estateId=${payload.estateId}&officeId=${payload.officeId}&actionType=${payload.actionType}&settingType=${payload.settingType}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

export const saveOfficesListInLocalDB = async (body) => {
    try {
        let url = `${variables.API_URL}Settings/PostOfficeDetailsInClientSetting`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.post(url, body, jsonconfig);

        if (response.data) {
            console.log(response.data);
            //return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

export const getEstateAllEventsCount = async (estateId, clientId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetEstateAllEventsCounts?estateId=${estateId}&clientId=${clientId}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// get property status from estate table in local db
export const getHistoryActionLogs = async (body) => {
    try {
        const url = `${variables.API_URL}LocalEvents/GetActionLog?estateId=${body.estateId}&parentLogId=${body.actionLogId}&actionType=${body.actionType}&dateFrom=${body.startDate}&dateTo=${body.endDate}&performedBy=${body.performBy}&pageNumber=${body.pageNumber}&pageSize=${body.pageSize}`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.get(url, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// get action type 
export const getActionType = async () => {
    try {
        const url = `${variables.API_URL}LocalEvents/GetActionTypes`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.get(url, config);
        if (response.data) {
            const filteredData = response.data?.data?.filter(item => item.id !== 10 && item.id !== 11) ?? [];
            return { ...response.data, data: filteredData };
        }
    } catch (error) {
        console.log(error);
    }
}

// update parent action log
export const updateParentActionLog = async (body) => {
    try {
        const url = `${variables.API_URL}LocalEvents/UpdateParentActionLog?parentLogId=${body.parentLogId}&metaData=${body.metadata}&exception=${body.exception}`;

        let config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.patch(url, config);

        if (response.data) {
            console.log(response.data);
        }
    } catch (error) {
        console.log(error);
    }
}

export const getEstatePurposeStatusListService = async (selectLanguage) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetPurposeStatusByEstate`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.get(url, config);
        if (response.data.data.length > 0) {
            return response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
}

export const getDisplayStatusService = async (selectLanguage) => {
    try {
        let url = `${variables.API_URL}Estate/GetCategory`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.get(url, config);
        if (response.data.data.length > 0) {
            return response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
}

